(function () {

	'use strict';

	/*global $:true */

	let cologicSortByTags = {

		initSortByTags: function () {

			// let that = this;
            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();

		},


        identifyDataTags: function (_classes, parentElement = '.crawlContainer ') {
            if (typeof(_classes) != 'undefined' && _classes != null && _classes !== ''){
                let dataTags = [];
                _classes.forEach((_class)=>{
                    // console.log($('.' +_class));
                    $(parentElement +' .'+_class).each(function(){
                        let json_data = $(this).data();
                        // console.log(json_data);

                        for(let i in json_data){
                            if(typeof(dataTags[i]) != 'undefined'){
                                dataTags[i].push(String(json_data[i]).trim().split(' '));
                            }else{
                                dataTags[i] = [];
                                // console.log(json_data[i]);
                                dataTags[i].push(String(json_data[i]).trim().split(' '));
                            }
                        }
                    });
                });
                // console.log(dataTags);
                return dataTags;
            }else{
                return [];
            }
		},





        enableTagButtonsForDataTags: function (_dataTags, elemClass, parentElement = '.crawlContainer ') {
            let out = '';
            // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
            out += '';
            if($(parentElement).hasClass('werbung-slider-filter')){
                // out += '<div class="tagBarBtnPrev"></div><div class="tagSectionInnerContainer">';
                out += '<div class="tagBarBtnPrev"></div><div class="tagSectionInnerContainer"><div class="tagSectionInner">';
            }
            let procArray = [];
            for(let i in _dataTags){
                // if(i == 'kategorie'){
                    out += '<div class="btn tagBtn active" data-wert="all" data-kategorie="'+i+'">Alle</div>';

                    procArray[i] = [];
                    // console.log(i);
                    // console.log(_dataTags[i]);
                    // console.log(_dataTags[i]);
                    // if(_dataTags[i][0] != ''){
                    _dataTags[i].forEach((selectTag) =>{
                        // console.log(selectTag);
                        // console.log(i);

                        selectTag.forEach((tag) => {
                            if(typeof(procArray[i][tag]) == 'undefined') {
                                if(tag != ''){
                                    procArray[i][tag] = 1;
                                    let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1);
                                    fineTag = fineTag.replaceAll('_',' ',);
                                    fineTag = fineTag.replaceAll('ue','ü',);
                                    fineTag = fineTag.replaceAll('ae','ä',);
                                    fineTag = fineTag.replaceAll('oe','ö',);
                                    out += '<div class="btn tagBtn" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
                                }
                            }
                        });
                    });
                    // out += '</div>';
                    // }

                // }
            }
            if($(parentElement).hasClass('werbung-slider-filter')){
                out += '</div></div><div class="tagBarBtnNext"></div>';
            }


            out += '';
            // console.log('parent:');
            // console.log($(parentElement));
            $(parentElement + ' .crawlInner .tagSection').html(out);
            // if (typeof(_dataTags) != 'undefined' && _dataTags != null && _dataTags !== '' && _dataTags.length > 0){
            //     _dataTags.forEach((_dataTag)=>{
            //         console.log(_dataTag);
            //     });
            // }
            $('.tagBtn').each(function (){
                $(this).bind('click', function(){
                    let that = this;
                    // $('.tagBtn').each(function (){
                    //     if(!$(this).hasClass('active')){
                    //         let kategorie = $(this).data('kategorie');
                    //         let wert = $(this).data('wert');
                    //         let found = false;
                    //         $('.'+elemClass).each(function(){
                    //             if($(this).data(kategorie).indexOf(wert) != -1){
                    //                 // $(this).toggleClass(kategorie);
                    //                 // $(this).toggleClass(wert);
                    //                 $(this).parent().removeClass('active');
                    //                 // $(this).parent().parent().removeClass('active');
                    //             }
                    //         });
                    //     }
                    //
                    // });
                    $('.tagBtn').removeClass('active');
                    $(this).addClass('active');

                    let kategorie = $(this).data('kategorie');
                    // console.log(kategorie);
                    let wert = $(this).data('wert');
                    // console.log(wert);

                    if(wert == "all"){
                        $('.'+elemClass).parent().addClass('active');
                        $(this).addClass('active');

                    }else{

                        // let found = false;
                        $('.'+elemClass).each(function(){
                            // console.log($(this));
                            // console.log($(this).data(kategorie));
                            // console.log($(this).data(kategorie).toString().indexOf(wert));
                            if($(this).data(kategorie).toString().indexOf(wert) != -1){
                                // found = true;
                                // $(this).toggleClass(kategorie);
                                // $(this).toggleClass(wert);
                                // if(!$(that).hasClass('active')) {
                                //     $(this).parent().addClass('active');
                                //     // $(this).parent().parent().removeClass('active');
                                // }else{
                                    $(this).parent().addClass('active');
                                    // $(this).parent().parent().addClass('active');
                                // }
                            }else{
                                $(this).parent().removeClass('active');

                            }
                        });
                        // if(found){
                        //     $('.tagBtn').removeClass('active');
                        //     $(this).addClass('active');
                        //     // $(this).toggleClass('active');
                        // }

                    }


                })
            });

		},


        showAllBlogsInContainer: function (elemClass,parentElement = '.crawlContainer ') {
            $(parentElement + ' .'+elemClass).each(function(){
                    $(this).parent().addClass('active');

                });
        },
        // enableTagButtonsForDataTags: function (_dataTags, parentElement = '.crawlContainer ') {
        //     let out = '';
        //     // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
        //     let procArray = [];
        //     for(let i in _dataTags){
        //         if(i == 'kategorie'){
        //             procArray[i] = [];
        //             out += '<select id="kategorieFilter">';
        //             out += '<option value="all">Alle zeigen</option>';
        //
        //             _dataTags[i].forEach((selectTag) =>{
        //                 // console.log(i);
        //
        //                 selectTag.forEach((tag) => {
        //                     if(typeof(procArray[i][tag]) == 'undefined') {
        //                         if(tag != ''){
        //                             procArray[i][tag] = 1;
        //                             let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1);
        //                             fineTag = fineTag.replaceAll('_',' ',);
        //                             out += '<option value="' + tag + '">' + fineTag + '</option>';
        //
        //                         }
        //                     }
        //                 });
        //             });
        //             out += '</select>';
        //
        //
        //         }
        //     }
        //
        //
        //     $(parentElement + ' .crawlInner .katfil').html(out);
        //     setTimeout(function () {
        //         $(parentElement + ' #kategorieFilter').bind('change', function (){
        //             let that = this;
        //             let kategorie = 'kategorie';
        //             let wert = $(this).val();
        //             console.log(wert);
        //             // if(wert == 'all'){
        //             //     $(parentElement + ' .blog').parent().addClass('active');
        //             // }
        //             $(parentElement + ' .blog').each(function(){
        //                 if($(this).data(kategorie).indexOf(wert) != -1 || wert == 'all'){
        //                     $(this).parent().addClass('active');
        //                 }else{
        //                     $(this).parent().removeClass('active');
        //
        //                 }
        //             });
        //         });
        //
        //     },100);
        //
		// },


        sortByDataTag: function(_parent, _item, _tag, _order) {
        switch(_order){
            case "asc":
                $(_parent+' '+_item).sort(sort_up).appendTo(_parent);
                break;
            case "desc":
                $(_parent+' '+_item).sort(sort_down).appendTo(_parent);
                break;
        }

        function sort_up(a, b) {
            return ($(b).data(_tag)) < ($(a).data(_tag)) ? 1 : -1;
        }

        function sort_down(a, b) {
            return ($(b).data(_tag)) > ($(a).data(_tag)) ? 1 : -1;
        }
    },



	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSortByTags);
}());
